import { createFileRoute } from '@tanstack/react-router'
import { ResetPasswordPage } from '@pa/staff'
import { z } from 'zod'

const search = z.object({
  mode: z.string().optional().catch(undefined),
  oobCode: z.string().optional().catch(undefined),
  continueUrl: z.string().optional().catch(undefined),
})

/**
 * A-03, Firebase's email action handler (Frontend §5.2): `?mode=resetPassword&oobCode=&continueUrl=`. Firebase allows
 * one action URL per project (the clinic app's); this app mounts it too.
 */
export const Route = createFileRoute('/auth/action')({
  validateSearch: search,
  component: function AuthActionRoute() {
    const { mode, oobCode, continueUrl } = Route.useSearch()
    const { env } = Route.useRouteContext()
    return (
      <ResetPasswordPage
        siteName="PF Appointments"
        mode={mode}
        oobCode={oobCode}
        continueUrl={continueUrl}
        allowedOrigins={[window.location.origin, env.VITE_ADMIN_APP_ORIGIN]}
      />
    )
  },
})
